/* eslint-disable */
import * as http from '@/utils/http';

var mind = {
  "meta": {
    "name": "jsMind remote",
    "author": "hizzgdev@163.com",
    "version": "0.2"
  },
  "format": "node_array",
  "data": []
};

var mindmapid = 0;
var mainMindMap = null;

function getSelected(node, selected) {
  selected = selected || {};
  if (node.selected) {
    selected[node.id] = node.id;
  } else {
    delete selected[node.id];
  }
  return selected;
}

// 让 jm 显示这个 mind 即可
export default function mindMap(container, dataoptions) {
  if (!document.getElementById(container)) {
    return false;
  }
  var option = {
    container: container,
    theme: 'orange',
    mode: 'full',
    view: {
      hmargin: 5, // 思维导图距容器外框的最小水平距离
      vmargin: 5, // 思维导图距容器外框的最小垂直距离
      line_color: '#555' // 思维导图线条的颜色
    },
    layout: {
      hspace: 30, // 节点之间的水平间距
      vspace: 14, // 节点之间的垂直间距
      pspace: 16 // 节点收缩/展开控制器的尺寸
    }
  };
  var selected = {};
  var _jm = new jsMind(option);
  var rootData = { "id": "0", "isroot": true, "topic": "思维导图" };
  // if (mind.data.length === 0) {
  http._get({
    url: `/index/mind_map/getMindData/cid/${dataoptions.cid}`
  }).then(({ data }) => {
    data.unshift(rootData);
    mind.data = data;
    _jm.show(mind);
  });
  _jm.add_event_listener(function(type, data) {
    switch (type) {
      case 1:
        if (!dataoptions.link_id) {
          break;
        }
        http._get({
          url: `/index/mind_map/getMindCheckedData/table/${dataoptions.table}/lid/${dataoptions.link_id}`,
        }).then(function({ data }) {
          selected = data;
          for (var i in data) {
            _jm.selectNode(i);
          }
        });
      case 2:
        document.querySelector(`#${option.container}`).style.height = (_jm.view.size.h + 30) + 'px';
        // $('#' + option.container).css({ height: _jm.view.size.h + 30 });
        break;
      case 5:
        if (data.isroot) {
          break;
        }

        selected = getSelected(data, selected);
        var data = {
          content: selected,
          table: dataoptions.table,
          lid: dataoptions.link_id,
        };
        !dataoptions.vue.infoReadOnly && http._post({
          url: '/index/mind_map/saveMind',
          data
        }).then(function() {

        });
      case 6:
        data.data && (dataoptions.vue.mindDataText = data.data.content.trim());
    }
  });

  return _jm;
}

function updateMindMap(linkId) {
  $.post(updateMindUrl, { id: mindmapid, link_id: linkId }, function() {

  });
}
// window.onload = function () {
//   mainMindMap = mindMap('jsmind_container1', {
//     table: 'crm',
//     link_id: window.crmid1,
//   });
// }
